<template>
  <v-container class="px-8">
    <v-row justify="center">
      <v-col class="contentCol">
        <v-row v-if="$vuetify.breakpoint.mdAndUp" class="ma-0" justify="end">
          <v-icon @click="mode = 'list'" :color="mode === 'list' ? 'text' : '#757575'">mdi-format-list-text</v-icon>
          <v-icon class="ml-5" @click="mode = 'grid'" :color="mode === 'grid' ? 'text' : '#757575'">mdi-grid-large</v-icon>
        </v-row>
        <!-- Row of project cards -->
        <v-row v-if="mode === 'grid'" class="projectRow pb-md-0" justify="center">
          <v-col cols="12" v-for="(project, i) in projects" :key="i" md="6" lg="4" class="px-6">
            <v-hover v-slot:default="{ hover }" class="text-right hover">
              <v-card class="rounded-lg justify-center d-flex align-center py-6" :color="project.colour" height="265"
                      :ripple="false" flat @click="viewProject(project.link)">
                <v-icon class="projectIcon ma-12" size="110" color="#FFFFFF">{{ project.icon }}</v-icon>
                <v-fade-transition>
                  <v-overlay v-if="hover || $vuetify.breakpoint.mobile" absolute color="transparent" style="z-index: 1">
                    <v-col cols="10">
                      <v-row align="center" class="mt-3 text-body-1 font-weight-bold">
                        {{ project.tech }}
                      </v-row>
                      <v-row class="text-body-2">{{ project.type }}</v-row>
                    </v-col>
                    <v-col cols="2" class="flex-column text-right pa-0">
                      <v-icon color="#FFFFFF" large>{{  project.btn === 'Visit Website' ? 'mdi-web' : 'mdi-github' }}</v-icon>
                    </v-col>
                  </v-overlay>
                </v-fade-transition>
              </v-card>
            </v-hover>
            <v-row class="ma-2 align-center">
              <p class="mb-0 text-body-1 font-weight-medium">{{ project.name }}</p>
            </v-row>
          </v-col>
        </v-row>
        <div v-else class="mb-7">
          <v-row v-for="(project, i) in projects" :key="i" class="projectRow px-6">
            <v-col cols="8" md="5" class="d-flex align-center" @click="viewProject(project.link)" style="cursor: pointer">
              <v-row class="align-center my-2">
                <div class="rounded" :style="'background-color: ' + project.colour">
                  <v-icon class="projectIcon my-2 my-md-4 mx-3 mx-md-5" size="30" color="#FFFFFF">{{ project.icon }}</v-icon>
                </div>
                <p class="ml-6 ml-md-12 mb-0 text-body-1 font-weight-medium">{{ project.name }}</p>
              </v-row>
            </v-col>
            <v-col v-if="$vuetify.breakpoint.mdAndUp" cols="3" class="d-flex align-center">
              <v-row class="align-center my-2">
                <v-icon size="20">mdi-xml</v-icon>
                <p class="mb-0 ml-3 text--secondary">{{ project.tech }}</p>
              </v-row>
            </v-col>
            <v-col v-if="$vuetify.breakpoint.mdAndUp" cols="2" class="d-flex align-center">
              <v-row class="align-center my-2">
                <v-icon size="20">mdi-tag-outline</v-icon>
                <p class="mb-0 ml-3 text--secondary">{{ project.type }}</p>
              </v-row>
            </v-col>
            <v-col cols="4" md="2" class="d-flex align-center">
              <v-row v-if="$vuetify.breakpoint.mdAndUp" class="align-center my-2">
                <v-icon size="20">{{ project.btn === 'Visit Website' ? 'mdi-web' : 'mdi-github' }}</v-icon>
                <p class="mb-0 ml-3 text--secondary">{{ project.btn === 'Visit Website' ? 'Online' : 'Archived' }}</p>
              </v-row>
              <v-btn v-else color="transparent" class="text-capitalize" :href="project.link" target="_blank" depressed>
                <v-icon size="20">{{ project.btn === 'Visit Website' ? 'mdi-web' : 'mdi-github' }}</v-icon>
                <p class="mb-0 ml-3 mr-1 text--secondary">View</p>
                <v-icon color="#757575" size="12">mdi-open-in-new</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </div>


      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Projects',
  data: () => ({
    mode: 'grid',
    projects: [
      {
        name: 'UofT Index',
        tech: 'Vue • Express • MongoDB',
        link: 'https://uoftindex.ca',
        type: 'Web App',
        icon: 'mdi-book-open-page-variant',
        btn: 'Visit Website',
        colour: '#004699',
        showInfo: false
      },
      {
        name: 'Safe Grid',
        tech: 'Vue • Python • PostgreSQL',
        link: 'https://safegrid.ca',
        type: 'Web App',
        icon: 'mdi-map-outline',
        btn: 'Visit Website',
        colour: '#DC143C',
        showInfo: false
      },
      {
        name: 'Notebyte',
        tech: 'Vue • FastAPI • PostgreSQL',
        link: 'https://notebyte.dev',
        type: 'Web App',
        icon: 'mdi-console-line',
        btn: 'Visit Website',
        colour: '#3b82f6',
        showInfo: false
      },
      {
        name: 'EV ChargeCycle',
        tech: 'Vue • Pinia • Firebase',
        link: 'https://evchargecycle.web.app',
        type: 'Mobile Web App',
        icon: 'mdi-car-electric',
        btn: 'Visit Website',
        colour: '#007051',
        showInfo: false
      },
      {
        name: 'Cubing Cafe',
        tech: 'Vue • GraphQL • Mongoose',
        link: 'https://cubingcafe.web.app',
        type: 'Group Project',
        icon: 'mdi-cube-scan',
        btn: 'Visit Website',
        colour: 'orange',
        showInfo: false
      },
      {
        name: 'Kijiji Mapper',
        tech: 'Java • Maven • HTML',
        link: 'https://github.com/lynjust2/Kijiji-Crawler-Assignment',
        type: 'Group Project',
        icon: 'mdi-map-marker-multiple-outline',
        btn: 'View Github',
        colour: '#373373',
        showInfo: false
      }
    ]
  }),
  methods: {
    viewProject(link) {
      window.open(link, '_blank').focus()
    }
  }
}
</script>

<style scoped>
  >>>.theme--light.v-sheet {
    color: transparent;
  }
  >>>.theme--dark.v-sheet {
    color: transparent;
  }
  >>>.v-overlay__content {
    height: 100%;
    width: 100%;
    text-align: left;
    padding: 15px;
    display: flex;
    align-items: flex-end;
  }

  .projectRow {
    padding-top: 10px;
    margin: 0 -24px;
  }

</style>
